/**
 * Паттерн поддомена записи: m5472.beclients.ru или dev-m5472.beclients.ru
 */
export const BOOKING_HOST_PATTERN = /^(?:dev-)?m(\d{4,6})\.beclients\.ru$/;

/**
 * Извлекает publicCode из hostname, если это поддомен записи (m*.beclients.ru).
 * На localhost возвращает null.
 */
export function getSlugFromHost(): string | null {
  if (typeof window === 'undefined') return null;
  const match = window.location.hostname.match(BOOKING_HOST_PATTERN);
  return match ? match[1] : null;
}

/**
 * true, если текущий хост — поддомен записи (корень можно показывать как страницу записи)
 */
export function isBookingSubdomain(): boolean {
  return getSlugFromHost() !== null;
}

/** Паттерн publicCode в query (4–6 цифр) для localhost/?code=5472 */
export const CODE_QUERY_PATTERN = /^\d{4,6}$/;

/**
 * Для localhost: извлекает code из ?code=5472 (для честного короткого URL без /booking/5472)
 */
export function getSlugFromQuery(): string | null {
  if (typeof window === 'undefined') return null;
  const code = new URLSearchParams(window.location.search).get('code');
  return code && CODE_QUERY_PATTERN.test(code) ? code : null;
}
